/** @jsx React.DOM */

var React = require("react/addons");
var TerminalsActions = require("editor/actions/TerminalsActions");
var TerminalsStore = require("editor/stores/TerminalsStore");
var WatchStoreMixin = require("editor/mixins/WatchStore");

var RunnerBox = React.createClass({displayName: 'RunnerBox',
  mixins: [ WatchStoreMixin(TerminalsStore) ],

  getFluxState: function() {
    return {
     currentTerminal: TerminalsStore.getCurrent()
    };
  },

  render: function() {
    return (
      React.DOM.div({className: "btn-toolbar", role: "toolbar"}, 
        React.DOM.div({className: "input-group"}, 
          React.DOM.input({type: "text", className: "form-control", ref: "commandTxt"}), 
          React.DOM.div({className: "input-group-btn"}, 
            React.DOM.button({type: "button", className: "btn btn-default dropdown-toggle", 'data-toggle': "dropdown"}, "Run ", React.DOM.span({className: "caret"})), 
            React.DOM.ul({className: "dropdown-menu dropdown-menu-right", role: "menu"}, 
              React.DOM.li(null, React.DOM.a({href: "#", onClick: this.handleRunCommandInNewTerminal}, "Run in new terminal")), 
              React.DOM.li(null, React.DOM.a({href: "#", onClick: this.handleRunCommandInCurrentTerminal}, "Run in current terminal"))
            )
          )
        )
      )
    );
  },

  handleRunCommandInNewTerminal: function() {
    var cmd = this.refs.commandTxt.getDOMNode().value;
    TerminalsActions.runCommandInNewTerminal(cmd, {
      cols: 160,
      rows: 24
    });
  },

  handleRunCommandInCurrentTerminal: function() {
    var cmd = this.refs.commandTxt.getDOMNode().value;
    if (this.state.currentTerminal) {
      TerminalsActions.runCommand(this.state.currentTerminal, cmd);
    } else {
      TerminalsActions.runCommandInNewTerminal(cmd, {
        cols: 160,
        rows: 24
      });
    }
  }
});

module.exports = RunnerBox;






/*****************
 ** WEBPACK FOOTER
 ** ./src/editor/components/RunnerBox.js
 ** module id = 26
 ** module chunks = 0
 **/